import axios from '@/axios/api.request'

export const save = (from) => axios.request({
    url: '/software/save',
    data: from,
    method: 'post'
  })
  export const decp = (from) => axios.request({
    url: '/software/decp',
    data: from,
    method: 'post'
  })